import React, { useEffect, useState } from "react";
import ResultCard from "../components/ResultCard";
import TopNav from "../components/TopNav";
import "./hompage.css";
import { BiSearchAlt } from "react-icons/bi";

import axios from "axios";
import Loading from "../components/Loading";
import CostumePagination from "../components/Pagination/CustomPagination";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
  },
});

const HomePage = () => {
  const [page, setPage] = useState(1);
  const [pageNums, setPageNums] = useState(0);
  const [search, setSearch] = useState("");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const fetchPosts = async () => {


    setLoading(true);
    setPosts([]);
    const { data } = await axios.get(
      `https://listendonate.herokuapp.com/api/posts?page=${page}`
      // `http://localhost:5000/api/posts?page=${page}`
    );
    setLoading(false);
    setPosts(data.result);
    setPageNums(data.pages);
  };

  const searchHandler = async (e) => {
    if (!e.key || e.key === "Enter") {
      setLoading(true);
      setError("")
      setPosts([]);
      setPage(1);
      setPageNums(0)
      try {
        const { data } = await axios.get(
          `https://listendonate.herokuapp.com/api/posts/search?name=${search.toLowerCase()}&page=${page}`
          // `http://localhost:5000/api/posts/search?name=${search.toLowerCase()}&page=${page}`
        );
        setLoading(false);
        setPosts(data.result);
        setPageNums(data.pages);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchPosts();
    // eslint-disable-next-line
  }, [page]);

  return (
    <div className="hompageWrap">
      <TopNav />
      <div className="search_wrap search_wrap_3">
        <div className="search_box">
          <input
            type="text"
            className="input"
            placeholder="Search by song or singer"
            value={search}
            onKeyPress={(e) => searchHandler(e)}
            onChange={(e) => setSearch(e.target.value)}
          />
          <div className="btn btn_common" onClick={searchHandler}>
            <BiSearchAlt className="searchIcon" />
          </div>
        </div>
      </div>
      {loading && <Loading />}
      {error && (
        <h3 className="noResult">No Result with this name. Try Another!</h3>
      )}
      <div className="results">
        {posts.map((post) => (
          <ResultCard item={post} />
        ))}
      </div>
      {!error && (
        <ThemeProvider theme={darkTheme}>
          <CostumePagination setPage={setPage} numPages={pageNums} />
        </ThemeProvider>
      )}
    </div>
  );
};

export default HomePage;
